// Module
var code = `<svg xmlns="http://www.w3.org/2000/svg" width="10.443" height="7.801" viewBox="0 0 10.443 7.801"> <path d="M4.057 7.8 0 3.745 1.414 2.33l2.643 2.643L9.029 0l1.414 1.414z"/> </svg> `;
// Exports
var _module_exports =code;;
var path = 'icons/checkmark.svg';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;